import * as ReactDOM from "react-dom";

import { BrowserRouter } from "react-router-dom";
import App from "./app";
import React from "react";
import { MuiThemeProvider } from "material-ui";
import ThemeDefault from "./theme-default";
import "./design-system.css";
import "./styles.scss";
import { Provider } from "react-redux";
import store from "./redux/store";

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider muiTheme={ThemeDefault}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MuiThemeProvider>
  </Provider>,
  document.getElementById("root")
);

// A legacy create-react-app service worker cached stale bundles in some
// browsers. Unregister any worker and drop its caches so clients always
// load the freshly deployed app.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(reg => reg.unregister());
  });
  if (window.caches && window.caches.keys) {
    window.caches.keys().then(keys => {
      keys.forEach(key => window.caches.delete(key));
    });
  }
}
